import {alertConstants, appConstants} from '../_constants';
import {initialState} from "../_store";

export function airlinesPayments(state=initialState.airlinePayments, action) {
    switch (action.type) {
        case appConstants.AIRLINE_PAYMENT_SUCCESS:
            return Object.assign({}, state, action.airlines);
        case alertConstants.ERROR:
            return action.message;
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/airlinePayments.reducer.js